<template>
  <div-box>
    <wallet-head show_type="8" />
    <div-padding padding="3vw 4vw">
      <div-card bg='#242424' padding='3vw'>
        <!-- <div class="msgbox htmlcontentbox" v-html="infos.content"></div> -->

        <div v-if="getLang() == 'zh'" class="msgbox htmlcontentbox" v-html="infos.content"></div>
        <div v-if="getLang() == 'en'" class="msgbox htmlcontentbox" v-html="infos.content_en"></div>
        <div v-if="getLang() == 'tw'" class="msgbox htmlcontentbox" v-html="infos.content_tw"></div>


      </div-card>

    </div-padding>

  </div-box>
</template>
<script>
export default {
  data() {
    return {
      infos: {},
    }
  },
  created() {
    this.getdata()
  },
  methods: {
    getdata() {
      this.$get({
        // loading: true,
        url: "/api/v1/agreement?type=1",
        success: (res) => {
          this.infos = res.data
        },
        tip: () => { },
      })
    },
  },
}
</script>
<style lang='less' scoped>
.indexbox {
  width: 100%;
  padding: 15px 15px 40px;

  .bodybox {
    width: 100%;
    background: #242424 !important;
    border-radius: 6px 6px 6px 6px;
    padding: 20px 10px;

    .tit {
      width: 100%;
      font-size: 4vw;
      font-weight: 550;
    }

    .time {
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size: 12px;
    }

    .msgbox {
      width: 100%;
      color: #999999;
      font-size: 14px;
    }
  }
}
</style>